import React from "react";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { CheckBoxRound } from "./Checkbox";

export type PasswordHintResonseType = {
  status: boolean;
  errorMsg: string;
  htmlList: JSX.Element;
  generalHtml: JSX.Element;
};

const passwordHint = (
  requestPassword: string = "",
  showHtml: boolean = false
): PasswordHintResonseType => {
  let errorMessage: string = "",
    valid: boolean = true,
    htmlList: JSX.Element = <></>,
    errorCounter: number = 0,
    genetalHtml: JSX.Element = <></>;

  const errorLength = AppTranslation.text("be_least_8_chars_long");
  const errorUppercase = AppTranslation.text("have_leat_1_uppercahse");
  const errorLowercase = AppTranslation.text("have_least_1_uppercase");
  const errorNumber = AppTranslation.text("have_least_1_number");
  const errorSymbol = AppTranslation.text("have_least_1_special_chat");

  let validList = {
    long: true,
    lowerCase: true,
    upperCase: true,
    numeric: true,
    symbol: true,
  };

  if (requestPassword.length < 8) {
    errorMessage = errorLength;
    errorCounter++;
    validList = { ...validList, long: false };
  }

  if (requestPassword.search(/[a-z]/) < 0) {
    errorMessage = errorLowercase;
    errorCounter++;
    validList = { ...validList, lowerCase: false };
  }
  if (requestPassword.search(/[A-Z]/) < 0) {
    errorMessage = errorUppercase;
    errorCounter++;
    validList = { ...validList, upperCase: false };
  }
  if (requestPassword.search(/[0-9]/) < 0) {
    errorMessage = errorNumber;
    errorCounter++;
    validList = { ...validList, numeric: false };
  }
  //if (requestPassword.search(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]+/) < 0) {
  if (requestPassword.search(/[[\] !@#$%^&*()_+=\-{};':"\\|,<>/?]+/) < 0) {
    errorMessage = errorSymbol;
    errorCounter++;
    validList = { ...validList, symbol: false };
  }

  valid = errorCounter > 0 ? false : true;

  if (showHtml === true) {
    let allValid = false;

    if (
      validList.long &&
      validList.upperCase &&
      validList.lowerCase &&
      validList.numeric &&
      validList.symbol
    ) {
      allValid = true;
    }

    htmlList = (
      <div className={`font-size-13_14 ${allValid ? "d-none" : ""}`}>
        <div className=" pb-1">
          {AppTranslation.text("password_must_containt")}
        </div>
        <ul className="password-verification-guide-list">
          <li className={`${validList.long && "d-none"}`}>
            <CheckBoxRound status={validList.long === true} size={15} />
            <span>{errorLength}</span>
          </li>
          <li className={`${validList.upperCase && "d-none"}`}>
            <CheckBoxRound status={validList.upperCase === true} size={15} />
            <span>{errorUppercase}</span>
          </li>
          <li className={`${validList.lowerCase && "d-none"}`}>
            <CheckBoxRound status={validList.lowerCase === true} size={15} />
            <span>{errorLowercase}</span>
          </li>
          <li className={`${validList.numeric && "d-none"}`}>
            <CheckBoxRound status={validList.numeric === true} size={15} />
            <span>{errorNumber}</span>
          </li>
          <li className={`${validList.symbol && "d-none"}`}>
            <CheckBoxRound status={validList.symbol === true} size={15} />
            <span>{errorSymbol}</span>
          </li>
        </ul>
      </div>
    );
  }

  if (requestPassword === "") {
    htmlList = <></>;
  }
  if (valid === false) {
    genetalHtml = (
      <div className="font-size-13_14 font-gotham-book color-grey">
        {AppTranslation.text("password_not_match_criteria")}
      </div>
    );
  }

  return {
    status: valid,
    errorMsg: errorMessage,
    htmlList: htmlList,
    generalHtml: genetalHtml,
  };
};

export default passwordHint;
